import { Component } from '@angular/core';
import { ViewController } from 'ionic-angular';

@Component({
    selector: 'reaction',
    templateUrl: './reaction.html',
})
export class ReactionComponent {
    constructor(private viewCtrl: ViewController) { }

    public share(reaction: string): void {
        this.viewCtrl.dismiss(reaction);
    }
}


// WEBPACK FOOTER //
// ./src/components/reaction/reaction.ts